import React, { Component } from "react";
import { getRequest } from "../../api/ApiService";
import { logError } from "../../services/utils";
import AbbreviatedMillionNumberFormat from "../ui-building-blocks/numbers/AbbreviatedMillionNumberFormat";

class ResultsPanelBalanceSheet extends Component {
  constructor(props) {
    super(props);

    this.state = {
      total_assets: {},
      total_liabilities: {},
      total_equity: {},
      roundInUrl: props.roundInUrl
    };
  }

  componentWillReceiveProps(nextProps) {
    if (this.state.roundInUrl !== nextProps.roundInUrl) {
      this.setState(
        {
          roundInUrl: nextProps.roundInUrl
        },
        () => {
          this.fetchData();
        }
      );
    }
  }

  getBalanceSheet() {
    const base_url = `${process.env.REACT_APP_API_URL}team/report/balance_sheet/`;
    let url = `${base_url}?round_lte=${this.props.currentRound}`;
    if (
      this.state.roundInUrl !== null &&
      this.state.roundInUrl !== this.props.currentRound
    ) {
      url = `${base_url}?round_lte=${this.state.roundInUrl}`;
    }

    return getRequest(url);
  }

  fetchData() {
    this.getBalanceSheet()
      .then(res => {
        let total_assets = {};
        let total_liabilities = {};
        let total_equity = {};

        res.body.forEach(item => {
          let round_id = item.round;
          let round = this.props.rounds.find(i => i.id === round_id);
          let round_number = round.number;

          if (item["Total Assets"]) {
            total_assets[round_number] = item["Total Assets"];
          }

          if (item["Total Liabilities"]) {
            total_liabilities[round_number] = item["Total Liabilities"];
          }

          if (item["Total Equity"]) {
            total_equity[round_number] = item["Total Equity"];
          }
        });

        this.setState({
          total_assets,
          total_liabilities,
          total_equity
        });
      })
      .catch(err => {
        logError(err, "ResultsPanelBalanceSheet", "fetchData");
      });
  }

  getYear(offset) {
    const { currentRound } = this.props;
    const { roundInUrl } = this.state;

    let current_round = currentRound;
    if (roundInUrl !== null && roundInUrl !== currentRound) {
      current_round = roundInUrl;
    }

    let rounds = [current_round, current_round + 1, current_round + 2];
    if (current_round + 2 > this.props.rounds.length) {
      current_round = this.props.rounds[this.props.rounds.length - 1].number;
      rounds = [current_round - 2, current_round - 1, current_round];
    }

    return rounds[offset];
  }

  get year1() {
    return this.getYear(0);
  }

  get year2() {
    return this.getYear(1);
  }

  get year3() {
    return this.getYear(2);
  }

  getDataValue(key, year) {
    if (key in this.state) {
      let data = this.state[key];
      if (year in data) {
        return data[year];
      }
    }

    return 0;
  }

  getTotalAssets(year) {
    return this.getDataValue("total_assets", year);
  }

  get totalAssets1() {
    return this.getTotalAssets(this.year1);
  }

  get totalAssets2() {
    return this.getTotalAssets(this.year2);
  }

  get totalAssets3() {
    return this.getTotalAssets(this.year3);
  }

  getTotalLiabilities(year) {
    return this.getDataValue("total_liabilities", year);
  }

  get totalLiabilities1() {
    return this.getTotalLiabilities(this.year1);
  }

  get totalLiabilities2() {
    return this.getTotalLiabilities(this.year2);
  }

  get totalLiabilities3() {
    return this.getTotalLiabilities(this.year3);
  }

  getTotalEquity(year) {
    return this.getDataValue("total_equity", year);
  }

  get totalEquity1() {
    return this.getTotalEquity(this.year1);
  }

  get totalEquity2() {
    return this.getTotalEquity(this.year2);
  }

  get totalEquity3() {
    return this.getTotalEquity(this.year3);
  }

  componentDidMount() {
    this.fetchData();
  }

  render() {
    return (
      <div className="table-responsive">
        <table className="table">
          <thead>
            <tr>
              <th className="table-title text-center">
                <span></span>
              </th>
              <th className="table-title text-center">
                <span>YEAR {this.year1}</span>
              </th>
              <th className="table-title text-center">
                <span>YEAR {this.year2}</span>
              </th>
              <th className="table-title text-center">
                <span>YEAR {this.year3}</span>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr className="text-center">
              <th className="text-left">Total Assets</th>
              <td>
                <AbbreviatedMillionNumberFormat
                  value={this.totalAssets1}
                  prefix="$"
                />
              </td>
              <td>
                <AbbreviatedMillionNumberFormat
                  value={this.totalAssets2}
                  prefix="$"
                />
              </td>
              <td>
                <AbbreviatedMillionNumberFormat
                  value={this.totalAssets3}
                  prefix="$"
                />
              </td>
            </tr>
            <tr className="text-center">
              <th className="text-left">Total Liabilities</th>
              <td>
                <AbbreviatedMillionNumberFormat
                  value={this.totalLiabilities1}
                  prefix="$"
                />
              </td>
              <td>
                <AbbreviatedMillionNumberFormat
                  value={this.totalLiabilities2}
                  prefix="$"
                />
              </td>
              <td>
                <AbbreviatedMillionNumberFormat
                  value={this.totalLiabilities3}
                  prefix="$"
                />
              </td>
            </tr>
            <tr className="text-center">
              <th className="text-left">Total Equity</th>
              <td>
                <AbbreviatedMillionNumberFormat
                  value={this.totalEquity1}
                  prefix="$"
                />
              </td>
              <td>
                <AbbreviatedMillionNumberFormat
                  value={this.totalEquity2}
                  prefix="$"
                />
              </td>
              <td>
                <AbbreviatedMillionNumberFormat
                  value={this.totalEquity3}
                  prefix="$"
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }
}

export default ResultsPanelBalanceSheet;



// WEBPACK FOOTER //
// ./src/components/results/ResultsPanelBalanceSheet.js